<script lang="ts" setup>
const props = defineProps<{
  text: string;
  maxLength: number;
}>();

const isShowFullDescription = ref(false);
const isShowExpandBtn = computed(() => props.text.length > props.maxLength);
const shrunkText = computed(() => {
  if (props.text.length <= props.maxLength) return props.text;
  
  const lastChar = props.text[props.maxLength];
  return props.text.slice(0, props.maxLength + (lastChar === '>' ? 1 : lastChar === '<' ? -1 : 0)) + '...';
});
</script>

<template>
  <div class="folding-text-block">
    <div
      v-if="!isShowFullDescription"
      v-html="shrunkText"
    />

    <FoldableBlock v-model="isShowFullDescription">
      <div v-html="text" />
    </FoldableBlock>

    <div
      v-if="isShowExpandBtn"
      class="folding-text-block__expand-btn"
      @click="isShowFullDescription = !isShowFullDescription"
    >
      {{ isShowFullDescription ? 'Скрыть' : 'Развернуть' }}
    </div>
  </div>
</template>

<style lang="scss">
.folding-text-block {
  ul,
  ol {
    margin: 8px 0;
    padding-left: 16px;
    list-style: square;
    line-height: 1.2;
  }

  &__expand-btn {
    color: $hell-black-60;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: $hell-black-40;
      text-decoration: underline;
    }
  }
}
</style>
